import styled from 'styled-components';

export const Page = styled.div``;

export const Header = styled.section`
  max-width: ${({ theme }) => theme.container};
  margin: 24px auto 0;
  padding: 0 16px;
  h1{ color: ${({ theme }) => theme.colors.green[700]}; margin: 0 0 10px; }
`;

export const Section = styled.section`
  max-width: ${({ theme }) => theme.container};
  margin: 24px auto 0;
  padding: 0 16px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px;
`;

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray[200]};
  border-radius: 12px;
  padding: 18px;
  box-shadow: ${({ theme }) => theme.shadows.sm};
  h3 { margin: 0 0 8px; color: ${({ theme }) => theme.colors.green[700]}; }
  p { margin: 0; }
  ul {
    margin: 0;
    padding-left: 20px;
    list-style: disc;
  }
  li {
    margin-bottom: 4px;
  }
  img{ width: 100%; height: 180px; object-fit: cover; border-radius: 8px; margin-bottom: 10px; }
`;
